import packageJson from '../../package.json';
export const THOUSAND = 1000;
export const SIXTY = 60;
export const THIRTY = 30;
export const FIFTEEN = 15;
export const TEN = 10;
const timeSpan = '<span>{time}</span>';
const sessionEndedText = 'Session ended';
const sessionEndFrText = 'Fin de la session';
const basePath = packageJson.homepage;

export const appConstants = {
  ACCEPT_TYPE: 'application/json',
  FORMHERO_HOST: 'formhero.cloud',
  FLOW_AUTH: 'Authenticated',
  FLOW_UNAUTH: 'UnAuthenticated',
  MANULIFE_URL: 'https://www.manulife.ca',
  TIMEOUT: 'TIMEOUT',
  LOGOUT: 'LOGOUT',
  EXIT: 'EXIT',
  TIMEOUT_LOGOUT: 'TIMEOUT_LOGOUT',
  MAX_ACTIVITY: 'MAX_ACTIVITY',
  MAX_ACTIVITY_LOGOUT: 'MAX_ACTIVITY_LOGOUT',
  MAX_CIAM_ACTIVITY_LOGOUT: 'MAX_CIAM_ACTIVITY_LOGOUT',
  IDLE_TIMER: THOUSAND * SIXTY * FIFTEEN, // 15 minutes
  IDLE_TIMER_REMAINING: 60000, // milliseconds = 1 minute.
  INTERVAL_TIME: THOUSAND,
  DEBOUNCE_TIME: 500,
  LOGOUT_ROUTE: `${basePath}/logout`,
  BEGIN_MAX_ACTIVITY_TIME: 43140, //11 HR, 59 MINS = SECONDS
  END_MAX_ACTIVITY_TIME: 43200, // 12 HRS.
  PUBLIC_LOGOUT_ROUTE: `${basePath}/public/logout`,
  URL_FR_LANG: 'fr',
  URL_EN_LANG: 'en',
  MANULIFE_FR_LANG: 'fr-CA',
  MANULIFE_EN_LANG: 'en-CA',
  REDIRECT_ROUTE: `${basePath}/redirect`,
  SESSION_REFRESH_INTERVAL: THOUSAND * THIRTY, //30 seconds
  BFF_GB_TOKEN_VALIDATE: '/validateTransferToken',
  BFF_TOKEN_GENERATE: '/getJWTToken',
  BFF_TOKEN_UPDATE: '/saveState',
  SAVE_DOCUMENTS: '/saveDocuments',
  BFF_LOGOUT: '/logout',
  BFF_LOGOUT_FINAL: '/logoutfinal',
  BFF_REFRESH_COOKIE: '/refreshcookie',
  PDF_NAME_CHECK_ENGLISH: 'Manulife',
  PDF_NAME_CHECK_FRENCH: 'Manuvie',
};

export const errorContext = {
  errorEn: {
    pageTitle: 'Sorry!',
    headerText: `We can't show this page right now.`,
    bodyText: 'Need a little help getting back on track?',
    fineText: 'Check out ',
    anchorText: 'our support page',
  },
  errorFr: {
    pageTitle: 'Désole!',
    headerText: 'Nous ne pouvons pas afficher cette page pour le moment.',
    bodyText: 'Avez-vous besoin d’un coup de pouce pour revenir sur la bonne voie?',
    fineText: 'Jetez un coup d’œil à ',
    anchorText: ' notre page de soutien ',
  },
  unAuthorized: {
    pageTitle: 'HTTP Error 401',
    headerText: 'Unauthorized!',
    bodyText: 'You are not authorized to view this page.',
  },
};

export const errorModalContext = {
  errorEn: {
    headerText: 'Sorry! Something went wrong.',
    bodyText:
      'We couldn’t do what you asked. Try checking your internet connection. ' +
      ' Or wait a few minutes and try again.',
    error_modal_button_okay: 'OK',
  },
  errorFr: {
    headerText: 'Désolé! Il y a eu un problème.',
    bodyText:
      'Nous n’avons pas pu faire ce que vous avez demandé. Essayez de vérifier votre connexion Internet. ' +
      'Ou attendez quelques minutes et essayez de nouveau.',
    error_modal_button_okay: 'OK',
  },
};

export const langContent = {
  'en-CA': {
    LOGOUT: {
      HEADER: 'You’ve signed out',
      HEADER_WITHOUT_AUTH: sessionEndedText,
      CONTENT_WITH_AUTH:
        'We saved what you’ve entered so far.\nFor the next 48 hours, ' +
        'you can start again where you left off. If you’ve added documents, you’ll need to upload them again.',
      CONTENT_WITHOUT_AUTH: 'To start again, follow the link you first used to begin.',
      BUTTON_OK: 'OK',
    },
    EXIT: {
      HEADER: 'Exit?',
      CONTENT_WITH_AUTH:
        "You'll lose what you've entered on this page. To save it, finish this page and " +
        'click Next.\n\nFor the next 48 hours, you can start again where you left off. ' +
        "If you've added documents, you'll need to upload them again.",
      CONTENT_WITHOUT_AUTH: "You'll lose what you've entered so far.",
      BUTTON_EXIT: 'Exit',
      BUTTON_CANCEL: 'Cancel',
    },
    TIMEOUT: {
      HEADER: "We'll sign you out in 1 minute.",
      CONTENT_WITH_AUTH: timeSpan,
      CONTENT_WITHOUT_AUTH: timeSpan,
      BUTTON_SIGNOUT: 'Sign out now',
      BUTTON_CANCEL: 'Cancel',
    },
    TIMEOUT_LOGOUT: {
      HEADER: 'You’ve been away, so we signed you out.',
      HEADER_WITHOUT_AUTH: sessionEndedText,
      CONTENT_WITH_AUTH:
        'We saved what you’ve entered so far.\nFor the next 48 hours, you can start again where you left off. ' +
        'If you’ve added documents, you’ll need to upload them again.',
      CONTENT_WITHOUT_AUTH: 'You’ll need to start again. Sorry for the inconvenience.',
      BUTTON_OK: 'OK',
    },
    SAVE_AND_EXIT: 'Save and exit',
    DOWNLOAD_PDF: 'Download submission (PDF)',
    DOWNLOAD_TEXT: 'Here’s a copy of your submission. Keep it for your records.',
    DOWNLOAD_ARIA_LABEL: 'Download submission (PDF) Open a new Window',
    MAX_ACTIVITY: {
      HEADER: 'Your session will time out in 1 minute.',
      CONTENT_WITH_AUTH: `We'll sign you out in <span>{time}</span>`,
      CONTENT_WITHOUT_AUTH: `We'll sign you out in <span>{time}</span>.`,
    },
    MAX_ACTIVITY_LOGOUT: {
      HEADER: "You've been signed out",
      HEADER_WITHOUT_AUTH: sessionEndedText,
      CONTENT_WITH_AUTH:
        'We saved what you’ve entered so far.\nFor the next 48 hours you can start again where you left off. ' +
        'If you’ve added documents, you’ll need to upload them again. ',
      CONTENT_WITHOUT_AUTH: 'You’ll need to start again. Sorry for the inconvenience.',
      BUTTON_OK: 'OK',
    },
    MAX_CIAM_ACTIVITY_LOGOUT: {
      HEADER: 'Your session has expired!',
      HEADER_WITHOUT_AUTH: 'Your session has expired!',
      CONTENT_WITH_AUTH:
        'Please sign in again to continue. \n' +
        'We saved what you’ve entered so far.\nFor the next 48 hours you can start again where you left off. ' +
        'If you’ve added documents, you’ll need to upload them again. ',
      CONTENT_WITHOUT_AUTH: 'You’ll need to start again. Sorry for the inconvenience.',
      BUTTON_OK: 'OK',
    },
  },
  'fr-CA': {
    LOGOUT: {
      HEADER: 'Vous avez fermé votre session.',
      HEADER_WITHOUT_AUTH: sessionEndFrText,
      CONTENT_WITH_AUTH:
        'Nous avons enregistré ce que vous avez entré jusqu’à maintenant.<br>Pendant les 48 prochaines heures, ' +
        'vous pourrez reprendre là où vous en étiez, mais vous devrez téléverser vos documents de nouveau.',
      CONTENT_WITHOUT_AUTH: 'Pour recommencer, cliquez sur le lien que vous avez utilisé au tout début.',
      BUTTON_OK: 'OK',
    },
    EXIT: {
      HEADER: 'Sortir de la demande de prestations?',
      CONTENT_WITH_AUTH:
        'Vous perdrez ce que vous avez entré sur cette page. Pour ne pas les perdre, terminez cette page et cliquez ' +
        'sur Suivant.\n\nPendant les 48 prochaines heures, vous pourrez reprendre là où vous en étiez.' +
        'Vous devrez téléverser vos documents de nouveau.',
      CONTENT_WITHOUT_AUTH: 'Vous perdrez ce que vous avez entré jusqu’à maintenant.',
      BUTTON_EXIT: 'Sortir',
      BUTTON_CANCEL: 'Annuler',
    },
    TIMEOUT: {
      HEADER: 'Nous fermerons votre session dans 1 minute.',
      CONTENT_WITH_AUTH: timeSpan,
      CONTENT_WITHOUT_AUTH: timeSpan,
      BUTTON_SIGNOUT: 'Fermer la session maintenant',
      BUTTON_CANCEL: 'Annuler',
    },
    TIMEOUT_LOGOUT: {
      HEADER: 'Vous n’étiez plus là depuis un moment, nous avons donc fermé votre session',
      HEADER_WITHOUT_AUTH: sessionEndFrText,
      CONTENT_WITH_AUTH:
        'Nous avons enregistré ce que vous avez entré jusqu’à maintenant. ' +
        'Pendant les 48 prochaines heures, vous pourrez reprendre là où vous en étiez, ' +
        'mais vous devrez téléverser vos documents de nouveau.',
      CONTENT_WITHOUT_AUTH:
        'Vous devrez recommencer. Nous sommes désolés de tout inconvénient que cette situation pourrait vous causer.',
      BUTTON_OK: 'OK',
    },
    SAVE_AND_EXIT: 'Enregistrer et sorti',
    DOWNLOAD_PDF: 'Télécharger le formulaire de demande (PDF) ',
    DOWNLOAD_ARIA_LABEL: 'Télécharger le formulaire de demande (PDF) ouvre une nouvelle fenêtre',
    DOWNLOAD_TEXT: 'Voici une copie de votre formulaire de demande; veuillez la conserver dans vos dossiers.',
    MAX_ACTIVITY: {
      HEADER: 'Votre session expirera dans 1 minute.',
      CONTENT_WITH_AUTH: `Votre session sera fermée dans <span>{time}</span>`,
      CONTENT_WITHOUT_AUTH: `Votre session sera fermée dans  <span>{time}</span>.`,
    },
    MAX_ACTIVITY_LOGOUT: {
      HEADER: 'Votre session a été fermée.',
      HEADER_WITHOUT_AUTH: sessionEndFrText,
      CONTENT_WITH_AUTH:
        'Nous avons enregistré ce que vous avez entré jusqu’à maintenant. ' +
        'Pendant les 48 prochaines heures, vous pourrez reprendre là où vous en étiez. ' +
        'Si vous avez ajouté des documents, vous devrez les téléverser de nouveau.',
      CONTENT_WITHOUT_AUTH:
        'Vous devrez recommencer. Nous sommes désolés de tout inconvénient que cette situation pourrait vous causer.',
      BUTTON_OK: 'OK',
    },
    MAX_CIAM_ACTIVITY_LOGOUT: {
      HEADER: 'Votre session a expiré!',
      HEADER_WITHOUT_AUTH: 'Votre session a expiré!',
      CONTENT_WITH_AUTH:
        'Veuillez ouvrir une nouvelle session pour continuer. \n' +
        'Nous avons enregistré ce que vous avez entré jusqu’à maintenant. ' +
        'Pendant les 48 prochaines heures, vous pourrez reprendre là où vous en étiez. ' +
        'Si vous avez ajouté des documents, vous devrez les téléverser de nouveau.',
      CONTENT_WITHOUT_AUTH:
        'Vous devrez recommencer. Nous sommes désolés de tout inconvénient que cette situation pourrait vous causer.',
      BUTTON_OK: 'OK',
    },
  },
};

export const LOGOUT_TYPE = {
  signout: 'SIGNOUT',
  idle: 'IDLE',
  maxSession: 'MAX_SESSION',
};

// Logger related constants
// where the fallback values are set to be PROD values if the nginx fails in PROD
export const LOGGER_CONTEXT = {
  APP_NAME: window.__ENV__.ULS_APP_NAME || 'digitization-formhero-ui',
  APP_CI: window.__ENV__.ULS_APP_CI || 'CCI00002534162',
  ENVIRONMENT_CI: window.__ENV__.ULS_ENVIRONMENT_CI || 'CI00002534163',
  ENVIRONMENT: window.__ENV__.ULS_ENVIRONMENT || 'PROD',
  BFF_URL: window.__ENV__.BFF_URL || 'https://api.gbexperience.aks.manulife.ca/gb/bff/v2',
  LOG_PATH: '/log/v3/send',
};
